export const formatCurrency = (amount?: number, toFixedNumber = 2) => {
  if (!amount) return "";
  if (!toFixedNumber) {
    return `$${Math.round(amount / 100)}`;
  }
  return `$${(amount / 100).toFixed(toFixedNumber)}`;
};
